var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.client.id)?_c('span',[_vm._v(_vm._s(_vm.client.company || `${_vm.client.firstname} ${_vm.client.lastname}`))]):_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }